<!-- Non-interactive, static preview of an advertisement's primary asset -->
<!-- Sized according to the parent element -->

<template>
  <!-- Video (renders the first frame only - no controls, playback or interaction) -->
  <video
    v-if="asset?.isVideo"
    ref="video"
    :src="videoSrc"
    class="w-full h-full pointer-events-none select-none"
    preload="metadata"
    muted
    playsinline
    disablepictureinpicture
    disableremoteplayback
    tabindex="-1"
    @loadeddata="$emit('loaded-content')"
    @error="$emit('error')"
  />
  <!-- Image -->
  <img
    v-else
    :src="asset?.src"
    alt="Ad preview"
    class="w-full h-full"
    @load="$emit('loaded-content')"
    @error="$emit('error')"
  >
</template>

<script>
import InfoIcon from './Icons/InfoSimpleIcon.vue'

export default {
  name: 'BaseAdvertisementStaticPreview',
  components: {
    InfoIcon
  },
  props: {
    advertisement: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    asset () {
      const ad = this.advertisement
      const card = ad?.cards?.[0]
      const candidates = [
        { src: ad?.image, isVideo: false },
        { src: ad?.thumbnail, isVideo: false },
        { src: ad?.video, isVideo: true },
        { src: card?.image, isVideo: false },
        { src: card?.thumbnail, isVideo: false },
        { src: card?.video, isVideo: true }
      ]
      return candidates.find(({ src }) => src) || null
    },
    videoSrc () {
      // The media fragment forces Safari to decode and paint the first frame
      const src = this.asset?.src || ''
      return src.includes('#') ? src : `${src}#t=0.001`
    }
  },
  beforeDestroy () {
    // Abort any in-flight video download so unmounted previews don't hold open connections
    const video = this.$refs.video
    if (video) {
      video.removeAttribute('src')
      video.load()
    }
  }
}
</script>
